module.exports = __webpack_public_path__ + "static/media/contacts-form.50a2b0f9.xlsx";